import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import utils from './utils/util'
import * as filters from './filters'
import Service from './common/axios-config'
import ElementUI from 'element-ui'
import './assets/css/base.css'
import 'element-ui/lib/theme-chalk/index.css'
import 'default-passive-events'
import vuescroll from 'vuescroll';
Vue.use(vuescroll, {
  ops: {// 在这里设置全局默认配置
    bar: {
      background: '#ccc',
    },
  },
});
Vue.config.productionTip = false
Vue.use(ElementUI);
// 全局过滤器
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
// 全局工具
window.utils = Vue.prototype.utils = utils
window.$http = Vue.prototype.$http = Service

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
